import moment from "@/utils/moment";
import currencyMixin from "./generic/currencyMixin";

const couponsAndAcceptedDays = {
  "10OFF": [2, 3],
  JANEIRO10: [0, 1, 2, 3, 4, 5, 6, 7]
};

const invalidCouponMessages = {
  "10OFF":
    "O cupom informado é válido apenas para limpezas que ocorrerão em terças-feiras ou quartas-feiras!",
  JANEIRO10:
    "O cupom informado é válido apenas para limpezas que ocorrerão até terça-feira, 31/01!"
};

const couponNameExists = couponName =>
  Object.keys(couponsAndAcceptedDays).includes(couponName.toUpperCase());

const isCouponValid = (couponName, orderStartsAt) => {
  if (couponName.toUpperCase() === "JANEIRO10") {
    if (moment(orderStartsAt).isBefore("2023-02-01 00:00:00")) return true;

    return false;
  }

  if (couponName.toUpperCase() === "HOHOHO10") {
    if (moment(orderStartsAt).isBefore("2025-12-23 00:00:00")) return true;

    return false;
  }

  const dayOfWeek = moment(orderStartsAt).day();
  return couponsAndAcceptedDays[couponName.toUpperCase()].includes(dayOfWeek);
};

export default {
  methods: {
    isCouponByDayInvalid(couponName, orderStartsAt) {
      return (
        couponNameExists(couponName) &&
        !isCouponValid(couponName, orderStartsAt)
      );
    },

    invalidCouponByDayMessage(couponName) {
      return invalidCouponMessages[couponName.toUpperCase()];
    }
  },

  filters: {
    couponName(coupon) {
      return coupon.name;
    },

    couponDiscount(coupon) {
      const discountType = coupon.value_type;

      if (discountType === "PERCENTAGE") {
        return `${coupon.value}% de desconto`;
      }

      if (discountType === "VALUE") {
        return `${currencyMixin.filters.toCurrency(coupon.value)} de desconto`;
      }
    },

    couponDiscountAmount(amount) {
      return currencyMixin.filters.toCurrency(amount.subtotal.discount);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/couponMixin.js